module.exports = __webpack_public_path__ + "img/img_logo.37e349a7.png";